import { motion, useAnimation } from 'framer-motion';
import Link from 'next/link';
import { useRouter } from 'next/router';
import styled from 'styled-components';

import { ExclamationMarkSvg } from '../../assets/icons';
import theme from '../../assets/theme';
import { useMarketingMetrics } from '../../providers/PlausibleAnalyticsProvider';
import { IconWrapper } from './IconWrapper';

const AIAcceleratorBanner = () => {
  const router = useRouter();
  const animation = useAnimation();
  const { track } = useMarketingMetrics();

  const hoverSequence = async () => {
    await animation.start({ scale: 1.03, transition: { duration: 0.1 } });
    animation.start({ scale: 1, transition: { duration: 0.1 } });
  };
  return (
    <Banner
      animate={animation}
      onHoverStart={hoverSequence}
      onClick={() => {
        track('AcceleratorBanner.Clicked');
        router.push('https://curipod.com/accelerator');
      }}
    >
      <IconWrapper height="30px" width="30px">
        <ExclamationMarkSvg />
      </IconWrapper>
      <p
        style={{
          fontSize: 16,
          marginBottom: 0,
          fontWeight: 'bold',
          color: theme.colors.black,
        }}
      >
        Calling all innovative educators! Our AI accelerator program is the perfect
        opportunity to drive change in your school or district.{' '}
        <Link href="/accelerator">
          <a
            style={{
              fontSize: 16,
              textDecoration: 'underline',
              color: theme.colors.black,
              fontWeight: 'bold',
            }}
            onClick={e => {
              track('AcceleratorBanner.Clicked');
              e.stopPropagation();
            }}
          >
            Apply now!
          </a>
        </Link>
      </p>
    </Banner>
  );
};

const Banner = styled(motion.div)`
  background-color: ${theme.colors.betaYellow};
  color: ${theme.colors.black};
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.15);
  padding: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 20px;
  cursor: pointer;
`;

export default AIAcceleratorBanner;
